import { SecretStringInput } from 'browser/components/atomic-elements/atoms/input/secret-string-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
export const SecretStringInputField = LabelFieldFactory({ InputComponent: SecretStringInput })
